import { FILTER_BAR } from "./actionTypes";

const INIT_STATE = {
    regions: [],
    business: [],
    products: [],
    sections: [],
    snippets: [],
    users: [],
    loadingFilterData: true,
}
const FilterBarReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FILTER_BAR.GET_FILTER_DATA.REQUEST:
            return {
                ...state,
                loadingFilterData: true,
            };
        case FILTER_BAR.GET_FILTER_DATA.SUCCESS:
            return {
                ...state,
                regions: action.payload.regions,
                business: action.payload.business,
                products: action.payload.products,
                sections: action.payload.sections,
                snippets: action.payload.snippets,
                users: action.payload.users,
                loadingFilterData: false,
            };
        case FILTER_BAR.GET_FILTER_DATA.FAIL:
            return {
                ...state,
                loadingFilterData: false,
            };
        default:
            return state;
    }
}

export default FilterBarReducer;